export function convertirFechaISOaDDMMAAAA(fechaISO) {
  try {
    const fecha = new Date(fechaISO);
    const dia = ("0" + fecha.getDate()).slice(-2);
    const mes = ("0" + (fecha.getMonth() + 1)).slice(-2);
    const anio = fecha.getFullYear();
    return `${dia}/${mes}/${anio}`;
  } catch (e) {
    return "";
  }
}

export function convertirFechaDate(fecha) {
  try {
    if (fecha) {
      const fechaD = new Date(fecha);
      return fechaD;
    } else {
      return new Date();
    }
  } catch (e) {
    return new Date();
  }
}

export function limpiarTexto(texto) {
  try {
    // return texto.replace(/[^a-zA-Z0-9\s]/g, '');
    return texto.replace(/[^a-zA-ZÀ-ÿ0-9-.:;/(),*"\s]/g, "");
  } catch (e) {
    return texto;
  }
}
